import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

type RowNameTagStyleProps = {
    $cursor?: "default" | "help";
};

export const RowNameTag = styled(Text)<RowNameTagStyleProps>`
    background-color: ${colorsPalettes.carbon[50]};
    letter-spacing: 0.6px;
    border-radius: 16px;
    padding: 4px 5px;
    text-transform: uppercase;
    box-sizing: border-box;
    height: 16px;
    ${({ $cursor }) =>
        $cursor !== undefined &&
        css`
            cursor: ${$cursor};
        `}
`;

export const ScrollableAutocomplete = styled(FlexColumn)`
    /* Scrollable dropdown list */
    .ListItemsContainer {
        max-height: 240px;
        overflow-y: auto;
        overflow-x: hidden;

        /* Keep the line between input and the list sticky on vertical scroll */
        &::before {
            content: "";
            position: sticky;
            z-index: 1;
            top: 1px;
            height: 5px; /* sticky position of the line from the top */
        }
    }
`;
